/**
 * Create inline editor props for DOM elements.
 * @param type – text or html, where html gives rich editing tools.
 * @param path – Dot notated path to value to edit on the props object. Example: `"link.label"`.
 * @returns HTML data-* props that the inline editor parses.
 */
export function createEditableProps(type, path) {
    return {
        "data-editable": "true",
        "data-type": type,
        "data-path": path,
    };
}
